import { drilldownData, ModuleFields } from "@utils/drilldownData";

export const fields: any = {
  pageContents: drilldownData["pageContents"].map(
    ({
      fieldName,
      placeholder,
      name,
      formType,
      validation,
      className,
      loadOptions,
      options,
      usedFileType,
    }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      loadOptions,
      options,
      usedFileType,
    })
  ),
  FlightInfoHeaders: drilldownData["FlightInfoHeaders"].map(
    ({
      fieldName,
      placeholder,
      name,
      formType,
      validation,
      className,
      loadOptions,
      options,
      usedFileType,
    }: ModuleFields) => ({
      name: name,
      type: formType,
      label: fieldName,
      placeholder: placeholder,
      validation: validation,
      className: className,
      loadOptions,
      options,
      usedFileType,
    })
  ),
};
